var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgGem = function SvgGem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.025 5.145h4.277l3.399 9.82-.03.035L.026 5.145zm5.527 0h3.436l-.012-.012h.061l-.012.012h3.415l-3.442 9.763-.047.057-3.399-9.82zm8.138 0h4.277l-7.723 9.763 3.446-9.763zm2.21-1.063h-2.21v-.013h-3.407l3.87-4.074.085.088 3.758 3.949-.034.042-2.063.008zM5.29.007h3.407v-.012h4.277l.034.042-3.76 3.951-.082.088L5.29.006zM2.115 4.082H.026L.001 4.05 3.773.088l.085-.09L7.73 4.075H4.302v.01l-2.187-.002z"
  })));
};

export default SvgGem;